const formatCurrency = (value: number, currency: string, locale?: string): (string | JSX.Element)[] => {
    if (!locale) {
        locale = 'cs';
    }

    if (!currency) {
        return [<span key={1}>{value}</span>];
    }

    const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: value % 1 === 0 ? 0 : 2,
    });

    return formatter
        .formatToParts(value)
        .map((part, key) => (part.type === 'currency' ? <span key={key}>{part.value}</span> : part.value));
};

export default formatCurrency;
